import OrgInfo from './OrgInfo';

export default OrgInfo;



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/OrgInfo/index.jsx